import BaseButton from '@/components/base/BaseButton';
import BaseProgress from '@/components/base/BaseProgress';
import { useIntl } from '@/i18n';
import type { PlanSubscriptionDetailVO, PlanUsageVO } from '@/types';
import { SettingOutlined } from '@ant-design/icons';

interface PlanCapacityCardProps {
  detail: PlanSubscriptionDetailVO;
  usage: PlanUsageVO;
  onManage: () => void;
}

/** 订阅和人员用量按正式契约显示，直接使用服务端比例，不重新计算配额。 */
export default function PlanCapacityCard({
  detail,
  usage,
  onManage,
}: PlanCapacityCardProps) {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const { person } = usage;
  return (
    <section
      className="admin-plan-capacity py-2.5 px-3 rounded-md bg-surface-soft text-secondary text-[12px]"
      aria-label={t('layout.plan.capacity')}
    >
      <div className="admin-plan-heading flex items-center justify-between gap-2">
        <span>
          {t('layout.plan.label')} <strong>{detail.plan.name}</strong>
        </span>
        <BaseButton
          type="link"
          size="small"
          icon={<SettingOutlined aria-hidden />}
          onClick={onManage}
        >
          {t('layout.plan.manage')}
        </BaseButton>
      </div>
      <div className="admin-plan-description mt-[3px] [overflow-wrap:anywhere]">
        {t('sys.plan.usage.person')} {person.used}/
        {person.unlimited ? t('sys.plan.usage.unlimited') : person.max}
        {detail.planTo !== null && (
          <>
            {' '}
            · {t('layout.plan.expires')} {detail.planTo}
          </>
        )}
      </div>
      {!person.unlimited && person.ratio !== null && (
        <BaseProgress
          percent={person.ratio * 100}
          showInfo={false}
          size="small"
        />
      )}
    </section>
  );
}
